import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../../components/public/common/Layout';
import PageHeader from '../../../components/public/common/PageHeader';
import publicData from '../../../data/publicData.json';

const SitemapPage = () => {
  const { sitemap } = publicData;

  const renderSection = (section) => {
    if (Array.isArray(section)) {
      return (
        <ul className="space-y-2">
          {section.map((item, index) => (
            <li key={index}>
              <Link 
                to={item.path}
                className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300"
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      );
    }

    return (
      <div className="space-y-4">
        <Link 
          to={section.path}
          className="text-lg font-semibold text-gray-900 dark:text-white hover:text-blue-600 dark:hover:text-blue-400"
        >
          {section.title}
        </Link>
        {section.items && (
          <ul className="space-y-2 pl-4">
            {section.items.map((item, index) => (
              <li key={index}>
                <Link 
                  to={item.path}
                  className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300"
                >
                  {item.title}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

  return (
    <Layout>
      <PageHeader
        title="Sitemap"
        description="Complete list of all pages on our website"
        backgroundImage="/images/sitemap-header.jpg"
      />
      
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Main Navigation */}
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Main Navigation</h2>
            {renderSection(sitemap.main)}
          </div>

          {/* Services */}
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Services</h2>
            {renderSection(sitemap.services)}
          </div>

          {/* Case Studies */}
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Case Studies</h2>
            {renderSection(sitemap.caseStudies)}
          </div>

          {/* Legal Documents */}
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Legal Documents</h2>
            {renderSection(sitemap.legal)}
          </div>

          {/* Support Center */}
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Support Center</h2>
            {renderSection(sitemap.support)}
          </div>

          {/* Blog */}
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Blog</h2>
            {renderSection(sitemap.blog)}
          </div>
        </div>

        {/* Additional Information */}
        <div className="mt-12 text-center text-gray-600 dark:text-gray-400">
          <p>Last updated: {new Date().toLocaleDateString()}</p>
          <p className="mt-2">
            If you can't find what you're looking for, please{' '}
            <Link to="/contact" className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300">
              contact us
            </Link>
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default SitemapPage; 